import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NavigationService } from './services/NavigationService';
import { CheckoutService } from './services/CheckoutService';
import { CheckoutSettingsService } from './services/CheckoutSettingsService';
import { fetchTranslations } from '../utils/fetchTranslations';
import { withResultObserver } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
import { ShippingError } from '@wix/cashier-express-checkout-widget/dist/src/types/Shipping';
import { cashierExpressAddressToEcomAddress } from '../utils/cashierExpressAddressToEcomAddress';
import { getShippingMethods, getShippingOptions } from '../utils/getShippingMethods';
import { getPaymentBreakdown } from '../utils/getPaymentBreakdown';
import { getPaymentAmount } from '../utils/getPaymentAmount';
import { confirmPayment } from '@wix/cashier-express-checkout-widget/dist/src/utils/confirmPayment';
import { shouldNavigateToFastFlowCheckout } from '../utils/shouldNavigateToFastFlow';
import { getOrderItemsFromCheckout } from '../utils/getOrderItemsFromCheckout';
import { BIService } from './services/BIService';
import { SPECS } from './SPECS';
import { getDiscountsToAlignWith } from '../utils/discounts.utils';
import { trackInitiateCheckout } from '../utils/analytics.utils';
import { hasShippableItems } from '../utils/hasShippableItems';
import { createDeliveryOptionsServiceGetter } from './deliveryOptionsGetter';
export class ExpressCheckoutButtonsController {
  constructor(controllerParams) {
    var _this$controllerConfi6, _ref2;
    _defineProperty(this, "controllerParams", void 0);
    _defineProperty(this, "navigationService", void 0);
    _defineProperty(this, "checkoutService", void 0);
    _defineProperty(this, "checkoutSettingsService", void 0);
    _defineProperty(this, "biService", void 0);
    _defineProperty(this, "controllerConfig", void 0);
    _defineProperty(this, "getCurrency", void 0);
    _defineProperty(this, "currency", void 0);
    _defineProperty(this, "demoMode", void 0);
    _defineProperty(this, "translations", {});
    _defineProperty(this, "checkoutSettings", {});
    _defineProperty(this, "expressCheckoutSettings", void 0);
    _defineProperty(this, "getCheckoutId", void 0);
    _defineProperty(this, "onCancel", void 0);
    _defineProperty(this, "onClick", void 0);
    _defineProperty(this, "onPaymentMethodsInit", void 0);
    _defineProperty(this, "checkoutId", '');
    _defineProperty(this, "cartId", '');
    _defineProperty(this, "latestTotalAmount", '0');
    _defineProperty(this, "locale", void 0);
    _defineProperty(this, "isShippingMethodSelected", false);
    _defineProperty(this, "shouldUseExpressCheckoutSettings", false);
    _defineProperty(this, "deliveryOptionsServiceGetter", void 0);
    _defineProperty(this, "onShippingContactSelected", async shippingContact => {
      try {
        var _updatedCheckout$ship, _this$expressCheckout;
        const {
          country,
          city,
          subdivision,
          zipCode: postalCode
        } = cashierExpressAddressToEcomAddress(shippingContact);
        const address = {
          country,
          city,
          postalCode,
          subdivision
        };
        const updatedCheckout = await this.checkoutService.updateCheckoutForShippingEstimation(this.checkoutId, address);
        this.latestTotalAmount = getPaymentAmount(updatedCheckout);
        let shippingMethods;
        if (this.controllerConfig.essentials.experiments.enabled(SPECS.UseDeliveryOptionsLibInExpress)) {
          const options = await this.fetchDeliveryOptions(this.checkoutService.sdkCheckoutForDelivery);
          shippingMethods = getShippingOptions(options, updatedCheckout);
        } else {
          shippingMethods = getShippingMethods(updatedCheckout, this.translations);
        }
        if (shippingMethods && (!((_updatedCheckout$ship = updatedCheckout.shippingInfo) != null && _updatedCheckout$ship.selectedCarrierServiceOption) || shippingMethods.length === 0)) {
          return {
            error: ShippingError.SHIPPING_ADDRESS_UNSERVICEABLE
          };
        }
        const discountsToAlignWith = getDiscountsToAlignWith(updatedCheckout);
        return {
          shippingMethods,
          paymentBreakdown: getPaymentBreakdown(updatedCheckout, this.shouldUseExpressCheckoutSettings ? Boolean((_this$expressCheckout = this.expressCheckoutSettings) == null ? void 0 : _this$expressCheckout.taxOnProduct) : Boolean(this.checkoutSettings.taxOnProduct), discountsToAlignWith, this.controllerConfig.essentials.experiments.enabled(SPECS.UseConvertedPricesInExpress)),
          paymentAmount: getPaymentAmount(updatedCheckout)
        };
      } catch {
        return {
          error: ShippingError.SHIPPING_ADDRESS_UNSERVICEABLE
        };
      }
    });
    _defineProperty(this, "onPaymentAuthorized", async (_ref, shouldUpdateShippingAddress) => {
      let {
        error,
        detailsId,
        shippingContact,
        billingContact
      } = _ref;
      if (error) {
        return {
          result: 'error'
        };
      }
      let updatedCheckout;
      let deliveryOptions;
      const shouldUseDeliveryOptionsLibInExpress = this.controllerConfig.essentials.experiments.enabled(SPECS.UseDeliveryOptionsLibInExpress);
      const isMemberLoggedIn = this.controllerConfig.wixCodeApi.user.currentUser.loggedIn;
      this.biService.clickContinueEWalletModalSf(this.checkoutId, this.cartId ?? undefined);
      let shouldRedirectToCollectShipping = false;
      let hasShippingZipCodeError = false;
      let hasShippingSubdivisionError = false;
      try {
        updatedCheckout = await this.checkoutService.updateCheckoutByShippingContacts(this.checkoutId, shouldUpdateShippingAddress, billingContact, cashierExpressAddressToEcomAddress(shippingContact, billingContact));
        updatedCheckout = await this.checkoutService.updateCheckoutByBillingContacts(this.checkoutId, billingContact);
        if (shouldUseDeliveryOptionsLibInExpress && shouldUpdateShippingAddress && hasShippableItems(updatedCheckout) && !this.isShippingMethodSelected) {
          var _getShippingOptions, _deliveryOptions$erro, _deliveryOptions$erro2;
          deliveryOptions = await this.fetchDeliveryOptions(this.checkoutService.sdkCheckoutForDelivery);
          shouldRedirectToCollectShipping = ((_getShippingOptions = getShippingOptions(deliveryOptions, updatedCheckout)) == null ? void 0 : _getShippingOptions.length) !== 1;
          hasShippingZipCodeError = ((_deliveryOptions$erro = deliveryOptions.errors) == null ? void 0 : _deliveryOptions$erro.hasShippingZipCodeError) ?? false;
          hasShippingSubdivisionError = ((_deliveryOptions$erro2 = deliveryOptions.errors) == null ? void 0 : _deliveryOptions$erro2.hasShippingSubdivisionError) ?? false;
        }
      } catch {
        return {
          result: 'error'
        };
      }
      if (await shouldNavigateToFastFlowCheckout({
        checkout: updatedCheckout,
        prevTotalAmount: this.latestTotalAmount,
        shouldUpdateShippingAddress,
        checkoutSettings: this.checkoutSettings,
        expressCheckoutSettings: this.expressCheckoutSettings,
        checkoutService: this.checkoutService,
        needsShippingMethodSelection: !this.isShippingMethodSelected,
        biService: this.biService,
        isMemberLoggedIn,
        shouldUseDeliveryOptionsLibInExpress,
        shouldRedirectToCollectShipping,
        hasShippingZipCodeError,
        hasShippingSubdivisionError,
        shouldUseExpressCheckoutSettings: this.shouldUseExpressCheckoutSettings,
        experiments: this.controllerConfig.essentials.experiments
      })) {
        await this.navigationService.navigateToCheckout(updatedCheckout, detailsId);
      } else {
        var _result;
        const thankYouPageUrl = await this.navigationService.getThankYouPageUrlForPlaceOrder();
        const {
          orderId,
          paymentResponseToken
        } = await this.checkoutService.createOrderAndCharge({
          id: updatedCheckout.id,
          paymentToken: detailsId,
          urlParams: {
            errorUrl: await this.navigationService.getCheckoutErrorUrl(updatedCheckout, detailsId, this.controllerParams.contentAppId, this.controllerParams.contentComponentId),
            cancelUrl: await this.navigationService.getCheckoutCancelUrl(updatedCheckout, detailsId, this.controllerParams.contentAppId, this.controllerParams.contentComponentId),
            successUrl: thankYouPageUrl,
            pendingUrl: thankYouPageUrl
          }
        });
        if (!orderId) {
          return {
            result: 'error'
          };
        }
        const price = Number(updatedCheckout.payNowTotalAfterGiftCard.amount);
        let result;
        if (price > 0) {
          var _this$controllerConfi, _this$controllerConfi2, _this$controllerConfi3;
          result = await confirmPayment({
            chargeResponseToken: paymentResponseToken,
            meta: {
              appDefId: this.controllerConfig.appParams.appDefinitionId,
              msid: (_this$controllerConfi = this.controllerConfig.platformAPIs.bi) == null ? void 0 : _this$controllerConfi.metaSiteId,
              visitorId: (_this$controllerConfi2 = this.controllerConfig.platformAPIs) == null || (_this$controllerConfi2 = _this$controllerConfi2.bi) == null ? void 0 : _this$controllerConfi2.visitorId,
              widgetId: this.controllerParams.widgetId
            },
            biLoggerFactory: (_this$controllerConfi3 = this.controllerConfig.platformAPIs) == null ? void 0 : _this$controllerConfi3.biLoggerFactory,
            redirectFn: this.controllerConfig.wixCodeApi.location.to,
            newApi: true
          });
        }
        if (((_result = result) == null ? void 0 : _result.clientStatus) !== 'Pending') {
          await this.navigationService.navigateToThankYouPage(orderId);
        }
      }
      return {
        result: 'success'
      };
    });
    _defineProperty(this, "onShippingMethodSelected", async shippingMethod => {
      var _this$expressCheckout2;
      const fixCarrierIdForSelectShippingOptionExpress = this.controllerConfig.essentials.experiments.enabled(SPECS.FixCarrierIdForSelectShippingOptionExpress);
      const updatedCheckout = await this.checkoutService.setShippingOption(this.checkoutId, shippingMethod.identifier, fixCarrierIdForSelectShippingOptionExpress);
      this.latestTotalAmount = getPaymentAmount(updatedCheckout);
      this.isShippingMethodSelected = true;
      const discountsToAlignWith = getDiscountsToAlignWith(updatedCheckout);
      return {
        paymentAmount: getPaymentAmount(updatedCheckout),
        paymentBreakdown: getPaymentBreakdown(updatedCheckout, this.shouldUseExpressCheckoutSettings ? Boolean((_this$expressCheckout2 = this.expressCheckoutSettings) == null ? void 0 : _this$expressCheckout2.taxOnProduct) : Boolean(this.checkoutSettings.taxOnProduct), discountsToAlignWith, this.controllerConfig.essentials.experiments.enabled(SPECS.UseConvertedPricesInExpress))
      };
    });
    _defineProperty(this, "getInitialPaymentData", async () => {
      var _this$expressCheckout3, _this$checkoutSetting;
      const checkoutId = await this.getCheckoutId();
      const checkout = await this.checkoutService.getCheckoutByCheckoutId(checkoutId);
      this.controllerConfig.wixCodeApi.window.trackEvent(...trackInitiateCheckout({
        checkout
      }));
      this.checkoutId = checkout.id;
      this.cartId = checkout.cartId;
      this.latestTotalAmount = getPaymentAmount(checkout);
      const discountsToAlignWith = getDiscountsToAlignWith(checkout);
      return {
        orderItems: getOrderItemsFromCheckout(checkout, discountsToAlignWith, this.controllerConfig.essentials.experiments.enabled(SPECS.FixAdditionalFeeWithoutCode)),
        paymentBreakdown: getPaymentBreakdown(checkout, this.shouldUseExpressCheckoutSettings ? Boolean((_this$expressCheckout3 = this.expressCheckoutSettings) == null ? void 0 : _this$expressCheckout3.taxOnProduct) : Boolean((_this$checkoutSetting = this.checkoutSettings) == null ? void 0 : _this$checkoutSetting.taxOnProduct), discountsToAlignWith, this.controllerConfig.essentials.experiments.enabled(SPECS.UseConvertedPricesInExpress)),
        paymentAmount: getPaymentAmount(checkout)
      };
    });
    _defineProperty(this, "onPaymentMethodsInitInner", numberOfButtons => this.onPaymentMethodsInit({
      numberOfButtons
    }));
    _defineProperty(this, "fetchDeliveryOptions", async checkout => {
      var _checkout$shippingInf;
      const service = await this.deliveryOptionsServiceGetter();
      return service.getDeliveryOptions(checkout, (_checkout$shippingInf = checkout.shippingInfo) == null || (_checkout$shippingInf = _checkout$shippingInf.selectedCarrierServiceOption) == null ? void 0 : _checkout$shippingInf.code);
    });
    _defineProperty(this, "init", async () => {
      var _this$controllerConfi4, _this$controllerConfi5, _this$getCurrency, _this$expressCheckout4, _this$checkoutSetting2, _this$expressCheckout5, _this$checkoutSetting3;
      [this.translations, this.checkoutSettings] = await Promise.all([fetchTranslations(this.locale), ...(!this.shouldUseExpressCheckoutSettings ? [this.checkoutSettingsService.getSiteSettings()] : [])]);
      if (this.shouldUseExpressCheckoutSettings) {
        this.expressCheckoutSettings = await this.checkoutSettingsService.getExpressCheckoutSettings();
      }
      const domain = (_this$controllerConfi4 = this.controllerConfig.wixCodeApi) == null || (_this$controllerConfi4 = _this$controllerConfi4.location) == null ? void 0 : _this$controllerConfi4.baseUrl;
      const {
        appDefinitionId: appDefId,
        instanceId: appInstanceId,
        instance: appInstance
      } = this.controllerConfig.appParams || {};
      const {
        metaSiteId,
        visitorId,
        ownerId: siteOwnerId
      } = ((_this$controllerConfi5 = this.controllerConfig.platformAPIs) == null ? void 0 : _this$controllerConfi5.bi) || {};
      const meta = {
        appDefId,
        appInstanceId,
        siteId: metaSiteId,
        visitorId: visitorId,
        siteOwnerId,
        appInstance,
        consumerWidgetId: this.controllerParams.widgetId
      };
      const observe = withResultObserver(this.controllerConfig.setProps, {
        resultPropName: RESULT_PROP_NAME
      });
      const _expressCheckoutButtonsData = {
        legacyCurrency: (_this$getCurrency = this.getCurrency) == null ? void 0 : _this$getCurrency.call(this),
        locale: this.locale,
        domain,
        meta,
        taxOnProduct: this.shouldUseExpressCheckoutSettings ? Boolean((_this$expressCheckout4 = this.expressCheckoutSettings) == null ? void 0 : _this$expressCheckout4.taxOnProduct) : Boolean((_this$checkoutSetting2 = this.checkoutSettings) == null ? void 0 : _this$checkoutSetting2.taxOnProduct),
        translations: this.translations,
        demoMode: this.demoMode,
        onCancel: this.onCancel,
        onClick: this.onClick,
        isExpressSupported: this.shouldUseExpressCheckoutSettings ? Boolean((_this$expressCheckout5 = this.expressCheckoutSettings) == null ? void 0 : _this$expressCheckout5.isExpressSupported) : Boolean(!((_this$checkoutSetting3 = this.checkoutSettings) != null && _this$checkoutSetting3.delayCaptureEnabled)),
        ...observe({
          onShippingContactSelected: this.onShippingContactSelected,
          onPaymentAuthorized: this.onPaymentAuthorized,
          onShippingMethodSelected: this.onShippingMethodSelected,
          getInitialPaymentData: this.getInitialPaymentData,
          onPaymentMethodsInit: this.onPaymentMethodsInitInner
        }),
        setCurrency: currency => this.currency = currency
      };
      this.controllerConfig.setProps({
        _expressCheckoutButtonsData
      });
    });
    const {
      controllerConfig,
      continueShoppingUrl,
      successUrl,
      httpClient,
      getCurrency,
      getCheckoutId,
      demoMode,
      onCancel = () => {},
      onClick = () => {},
      onPaymentMethodsInit = () => {},
      locale,
      errorHandler
    } = controllerParams;
    this.controllerParams = controllerParams;
    this.navigationService = new NavigationService(controllerConfig, {
      continueShoppingUrl,
      successUrl
    });
    this.checkoutService = new CheckoutService(httpClient, errorHandler, controllerConfig, () => this.currency ?? (getCurrency == null ? void 0 : getCurrency()));
    this.checkoutSettingsService = new CheckoutSettingsService(controllerConfig);
    if (controllerConfig.essentials.experiments.enabled(SPECS.UseDeliveryOptionsLibInExpress)) {
      this.deliveryOptionsServiceGetter = createDeliveryOptionsServiceGetter(locale, httpClient, controllerConfig, errorHandler);
    }
    this.biService = new BIService(controllerConfig);
    this.controllerConfig = controllerConfig;
    this.getCurrency = getCurrency;
    this.demoMode = !!demoMode;
    this.getCheckoutId = getCheckoutId;
    this.onCancel = () => {
      this.isShippingMethodSelected = false;
      return onCancel();
    };
    this.onClick = onClick;
    this.onPaymentMethodsInit = onPaymentMethodsInit;
    const window = (_this$controllerConfi6 = this.controllerConfig.wixCodeApi) == null ? void 0 : _this$controllerConfi6.window;
    const fallbackLocale = (_ref2 = (window == null ? void 0 : window.locale) ?? (window == null ? void 0 : window.browserLocale) ?? 'en') == null ? void 0 : _ref2.split('-')[0];
    this.locale = locale ?? fallbackLocale;
    this.shouldUseExpressCheckoutSettings = this.controllerConfig.essentials.experiments.enabled(SPECS.UseExpressCheckoutSettings);
  }
}
//# sourceMappingURL=ExpressCheckoutButtonsController.js.map